export const getUniqueModules = (veevaStandardMappings) => {
  return [...new Set(veevaStandardMappings.map((mapping) => mapping.title || "General"))];
};

export const getFilteredVeevaMappings = (veevaStandardMappings, filterModule) => {
  if (filterModule === "all") {
    return veevaStandardMappings;
  }

  return veevaStandardMappings.filter((mapping) => (mapping.title || "General") === filterModule);
};

export const getFilteredClientMappings = (clientMappings, clientStatusFilter) => {
  if (clientStatusFilter === "all") {
    return clientMappings;
  }

  if (clientStatusFilter === "needs_review") {
    return clientMappings.filter((mapping) => mapping.status === "needs_review");
  }

  if (clientStatusFilter === "enabled") {
    return clientMappings.filter((mapping) => mapping.enabled);
  }

  if (clientStatusFilter === "disabled") {
    return clientMappings.filter((mapping) => !mapping.enabled);
  }

  return clientMappings;
};

export const buildManualClientMapping = (newClientMapping) => {
  const now = new Date().toISOString();
  const normalizedKey = `${newClientMapping.module}|${newClientMapping.veevaCRM}|${newClientMapping.vaultCRM}|custom`
    .toLowerCase()
    .replace(/\s+/g, "");

  return {
    id: normalizedKey,
    rowKey: normalizedKey,
    ...newClientMapping,
    enabled: true,
    status: "active",
    confidence: 1,
    notes: "",
    mappingType: "custom",
    source: "manual",
    sourceFile: "manual-entry",
    createdAt: now,
    updatedAt: now,
    lastSeenAt: now,
  };
};
